import { useProfileContext } from "@/context/ProfileContext";

/**
 * Returns the signed-in user's profile.
 *
 * The fetch/create logic now lives in {@link ProfileProvider} and runs exactly
 * once for the whole app (audit findings P6 + P11). This hook is a thin reader
 * over that shared context, so every call site sees the same profile instance
 * without triggering its own request. The return shape is intentionally
 * identical to the previous standalone implementation:
 * `{ profile, isLoading, error, refresh }`.
 */
export const useProfile = () => {
  return useProfileContext();
};
